import React, { useState } from "react";
import { Button, Box, Grid } from "@mui/material";
import styled from "@emotion/styled/macro";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_HOST, userSession } from "../services/auth/ApiService/client";
import CompanyFields from "./SignUp/CompanyFields";
import { initialUserData } from "./SignUp/model";
import UserFields from "./SignUp/UserFields";

const SignUpComponenr = styled(Box)``;

interface Props {
  modalOpen: () => void;
}

const SignUp: React.FC<Props> = ({ modalOpen }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);
  const [userData, setUserData] = useState(initialUserData);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      if (userData.password === userData.password2) {
        const response = await axios.post(`${API_HOST}/register`, {
          email: userData.email,
          password: userData.password,
          phone: userData.phone,
          company: userData.company,
          city: userData.city,
          legal: userData.legal,
        });

        const { accessToken, refreshToken, expTime, id } = response.data;
        userSession.initSession(accessToken, refreshToken, expTime, id);

        modalOpen();
        navigate("/profile");
      } else {
        const newErrors: string[] = [...errors];
        const errText = "Пароли не совпадают";
        if (newErrors.indexOf(errText) !== -1) {
          newErrors.push(errText);
          setErrors(errors);
        }
      }
    } catch (error) {
      console.error("Login error", error);
      // Handle errors (e.g., show error message)
    }
  };

  return (
    <SignUpComponenr>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={2}>
          {userData.legal && (
            <CompanyFields userData={userData} setUserData={setUserData} />
          )}
          <UserFields userData={userData} setUserData={setUserData} />
          {/* <Grid item xs={12} md={12} sx={{m: 1}}>
                        <FormControlLabel control={<Checkbox checked={userData.legal} onChange={() =>
                            setUserData(prev => ({
                                ...prev,
                                legal: !prev.legal,
                            }))
                        } />} label="Является юридическим лицом?" />
                    </Grid> */}
          <Grid item xs={12} md={12} sx={{ m: "0 auto" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{ m: 1, height: "56px" }}
            >
              Зарегистрироваться
            </Button>
          </Grid>
        </Grid>
      </form>
    </SignUpComponenr>
  );
};

export default SignUp;
